var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHistoria(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 200",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#831131"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.1,
    y: 195.5,
    width: 9.9,
    height: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.1,129.9l1.5-1l-11.3-11.5h26.8l0.4-0.2c0.5-0.3,11.4-6.9,21.7-24.4c17.1-29,18.8-64.7,17.2-89.5l-0.1-1.6l-1.6,0.2   c-2.1,0.2-50.5,6.4-72.4,23.8l-0.3,0.2l-9.1,22.4l-8-13.3l-1.3,0.9c-0.6,0.4-14,9.8-26.5,28.6c-11.5,17.3-24.1,46-19,84.7   c-6.1,10.2-10.9,20.7-13.6,31.1l2.9,0.7c2.6-10.2,7.3-20.4,13.3-30.4c0.8,0,1.9,0.1,3.3,0.1C51.4,150.6,87.3,148.9,115.1,129.9z    M37.4,147.6C66.3,101.5,121.4,61.5,122,61l-1.8-2.4C119.6,59,65,98.7,35.5,145.1c-3.7-35.8,8.1-62.5,18.9-78.8   c9.9-15,20.8-24.1,24.5-27l9.4,15.6l11-27.2c19.2-15,60.5-21.5,69-22.8c2.5,43.2-7.7,70.6-16.8,86c-9,15.2-18.6,22.1-20.5,23.3   H98.1l13.8,14.1C83.7,146.8,47.7,147.8,37.4,147.6z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.3,
    y: 195.5,
    width: 107.2,
    height: 3
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoria);
export default __webpack_public_path__ + "static/media/historia.4164ea728deb8536e2d72623bf564d0d.svg";
export { ForwardRef as ReactComponent };